import React, { useState, useEffect } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

function QuestionAnsweringComponent(props) {
    const [response, setResponse] = useState([]);
    const [loading, setLoading] = useState(false);

    // Function to reset the state
    const resetState = () => {
        setResponse([]);
    };

    const fetchQA = async () => {
    try {
        setLoading(true);
        console.log(props.currentRef);
        let row_id = props.currentRef;

        const response = await fetch(`${process.env.REACT_APP_BASE_URI}/get_qa/` + row_id, {
            method: 'GET',
            // headers: { 'Authorization': 'Bearer ' + getToken() } // Uncomment if token is needed
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const data = await response.json();
        setLoading(false);
        setResponse(data);
    } catch (error) {
        setLoading(false);
        console.error('Error fetching questions:', error);
    }
};

    useEffect(() => {
        if (props.show) {
            resetState();
            fetchQA(); // Fetch questions when modal is opened
        }
    }, [props.show]);

    return (
        <Modal {...props} centered animation={true} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>QA Dialog</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                ) : (
                    response.map((item, index) => (
                        <div key={index} className="question-answer">
                            <div className="question">
                                <strong>Question {index + 1}:</strong> {item.question}
                            </div>
                            <div className="answer-score">
                                <strong>Answer:</strong> {item.answer}
                                <br />
                                <strong>Score:</strong> {item.score}
                            </div>
                            <br />
                        </div>
                    ))
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-dark" onClick={props.onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default QuestionAnsweringComponent;